import React, { useEffect, useState, useRef } from 'react';
import { Routes, useNavigate, useLocation } from "react-router-dom";

import routes from '../../libs/routes';
import images from "../../libs/images";
import * as API from "../../libs/service";


import { useDispatch, useSelector } from 'react-redux';

import { loadingStart, loadingEnd } from "../../redux/loadingSlice";
import { open, close } from "../../redux/popupSlice";

import Popup01 from "../../pages/popup/Popup01"

import { ToastContainer, toast, Slide, Flip, Bounce } from 'react-toastify';
import { BrowserView, MobileView, isBrowser, isMobile, isChrome, isSafari, isIOS, isAndroid } from 'react-device-detect';
import { Swiper, SwiperSlide } from 'swiper/react';
import { FreeMode, Autoplay } from 'swiper/modules';



import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/autoplay';
import 'react-toastify/dist/ReactToastify.css';

import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import HLSVideo from '../../libs/hlsVideo';



const CONTENT_ITEMS = [
    {
        title: { ko: '커브 메쉬 에디터', en: 'Curve Mesh Editor' },
        description: {
        ko: 'Catmull-Rom Spline, Bezier, B-Spline 등의 곡선을 활용하여 부드럽고 자연스러운 3D 모델을 제작하세요. 정교한 곡선 조작을 통해 섬세한 형태와 유려한 디자인을 손쉽게 구현할 수 있습니다.',
        en: 'Use curves like Catmull-Rom Spline, Bezier,  and B-Spline to create smooth and natural 3D models.  Design precise shapes and intricate designs with  easy and accurate curve manipulation.'
        },
        video: "/m3u8/pro_01.m3u8",
        thum: require("../../assets/thumnails/pro_01_thum.webp"),
        reverse: false
    },
    {
        title: { ko: '2D 텍스트를 3D 모델로 구현', en: 'Convert 2D Text to 3D Models' },
        description: {
        ko: '입력한 텍스트에 원하는 폰트를 적용하여 손쉽게 3D 모델로 구현하세요. 두께, 곡률, 입체감 등을 자유롭게 조정하며, 직관적인 인터페이스로 빠르고 간편하게 디자인할 수 있습니다.',
        en: 'Apply fonts to your input text and easily transform it into 3D models.  Adjust width, depth, curvature, and other aspects with an intuitive  interface for fast and seamless design.'
        },
        video: "/m3u8/pro_02.m3u8",
        thum: require("../../assets/thumnails/pro_02_thum.webp"),
        reverse: true
    },
    {
        title: { ko: '자동 리토폴로지(준비중)', en: (<>{'Automatic Retopology'}<br />{'(Coming Soon)'}</>) },
        description: {
        ko: '리메셔를 활용해 고밀도 3D 모델을 효율적인 폴리곤 구조로 변환하세요. 디테일을 유지하면서 최적화하여 성능을 향상시키고 작업 속도를 극대화할 수 있습니다.',
        en: 'Use remeshing to efficiently transform high-poly 3D models  into optimized meshes. Maintain details while enhancing  performance and significantly speeding up your workflow.'
        },
        video: require("../../assets/pro_03.webp"),
        reverse: false
    },
    {
        title: { ko: '블렌드 쉐이프(준비중)', en: (<>{'Blend Shape'}<br />{'(Coming Soon)'}</>) },
        description: {
        ko: '3D 모델의 표정 변화와 애니메이션을 버텍스 단위로 정밀하게 조정하여 자연스럽고 생동감 있게 구현하세요. 간편한 조작으로 다양한 애니메이션 효과를 적용할 수 있습니다.',
        en: 'Refine 3D model shape and animations at the vertex level  for smooth and lifelike transformations.  Easily apply a variety of animation effects with simple controls.'
        },
        video: require("../../assets/pro_03.webp"),
        reverse: true
    },
    {
        title: { ko: '최신 기능을 가장 먼저 경험하세요', en: 'Experience the Latest Features First' },
        description: {
        ko: 'UModeler X Pro를 사용하면 최신 기능을 가장 먼저 경험할 수 있습니다. 지속적인 업데이트를 통해 혁신적인 도구와 향상된 워크플로우를 누구보다 빠르게 활용하세요. Pro 사용자는 한층 효율적인 3D 모델링을 경험할 수 있습니다.',
        en: 'With UModeler X Pro, be the first to experience the latest features.  Access cutting-edge tools and enhanced workflows through  continuous updates, enabling faster  and more efficient 3D modeling for Pro users.'
        },
        video: require("../../assets/pro_04.webp"),
        reverse: false
    }
];

    
export default function Extension() {
    const location = useLocation();
    
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const lang = useSelector(state => state.langReducer.lang);

    const [supBtnHover, setSupBtnHover] = useState(false);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    
    useEffect(() => {

    }, []);
    
    
    return (
        <>
            <div className="main_back">
                <div className="main_part padding">
                    <div className="header_page_title_box">
                        <p className="title">
                            {lang === 0 ? 'Pro 확장 기능' : 'Pro Extension Features'}
                        </p>
                        <span className="sub_title">
                            {lang === 0 ? 'UModeler X Pro가 제공하는 기능을 모두 만나보세요.' : 'Experience all the features provided by UModeler X Pro.'}
                        </span>
                    </div>

                    {/* 콘텐츠 섹션 */}
                    <div className="header_page_content_box">
                        {CONTENT_ITEMS.map((item, index) => {
                        return (
                            <div className={`content ${item.reverse ? 'end' : ''}`} key={index}>
                            {item.reverse ? (
                                <>
                                <div className="title_box">
                                    <p>{lang === 0 ? item.title.ko : item.title.en}</p>
                                    <span style={{ whiteSpace: 'pre-line' }}>
                                    {lang === 0 ? item.description.ko : item.description.en}
                                    </span>
                                </div>
                                {index === 2 || index === 3 || index === 4 ?
                                <div className="img_box_169" >
                                    <img src={item.video} alt={`content-${index}`} />
                                </div>
                                :
                                <div className="img_box">
                                    <HLSVideo
                                        width="100%"
                                        height="100%"
                                        autoPlay
                                        muted
                                        loop
                                        playsInline
                                        poster={item.thum}
                                        src={item.video}
                                    >
                                        소개 영상입니다.
                                    </HLSVideo>
                                </div>}
                                </>
                            ) : (
                                <>
                                {index === 2 || index === 3 || index === 4 ?
                                <div className="img_box_169" >
                                    <img src={item.video} alt={`content-${index}`} />
                                </div>
                                :
                                <div className="img_box">
                                    <HLSVideo
                                        width="100%"
                                        height="100%"
                                        autoPlay
                                        muted
                                        loop
                                        playsInline
                                        poster={item.thum}
                                        src={item.video}
                                    >
                                        소개 영상입니다.
                                    </HLSVideo>
                                </div>}
                                <div className="title_box">
                                    <p>{lang === 0 ? item.title.ko : item.title.en}</p>
                                    <span style={{ whiteSpace: 'pre-line' }}>
                                    {lang === 0 ? item.description.ko : item.description.en}
                                    </span>
                                </div>
                                </>
                            )}
                            </div>
                        );
                        })}
                    </div>
                </div>

                <div className="page_start_banner">
                    <div className="content">
                        <p className="title">
                            {lang === 0 ? 
                                <>
                                    UModeler X Pro 지금 만나보세요!
                                </>
                                :
                                <>
                                    Try UModeler X Pro Now!
                                </>
                            }
                        </p>

                        <div className="btn_box">
                            <button
                                type="button"
                                className={`start ${lang === 1 ? 'eng' : ''}`}
                                style={{width: 220,}}
                                onClick={() => {
                                    navigate(routes.Price);
                                }}
                            >
                                {lang === 0 ? '무료로 써보기' : 'Try for Free'}
                            </button>
                            <button
                                type="button"
                                className={`inquiry ${lang === 1 ? 'eng' : ''}`}
                                style={{width: 220,}}
                                onClick={() => {
                                    navigate(routes.Inquiry);
                                }}
                            >
                                {lang === 0 ? '문의하기' : 'Contact Us'}
                            </button>
                        </div>
                    </div>
                </div>
                
            </div> {/* 메인 div */}

            <ToastContainer
                position="bottom-center"
                transition={Slide}
                limit={1}
                closeButton={false}
                autoClose={1000}
                style={{ width: isBrowser ? 400 : '100%', marginBottom: isBrowser ? 60 : 70 }}
                hideProgressBar
            />
        </>
    );
}
